{
	"name": "Jolly Roger",
	"title": "Jolly Roger",
	"description": "Build and Deploy for Eternity",
	"canonicalURL": "http://localhost:8080",
	"ENSName": null,
	"themeColor": "#000000",
	"appleStatusBarStyle": "black-translucent",
	"icon": "static/icon.svg",
	"preview": "static/preview.png",
	"maskable": true
}
